import React from 'react';
import { colors } from './TabNavigation';
import { CONTACT_EMAIL } from './LegalPages';
import useIsMobile from './useIsMobile';

function Footer({ onNavigate }) {
  const isMobile = useIsMobile();
  const linkStyle = {
    background: 'none',
    border: 'none',
    padding: 0,
    fontFamily: 'inherit',
    fontSize: isMobile ? '13px' : '11px',
    fontWeight: '500',
    letterSpacing: '1.5px',
    textTransform: 'uppercase',
    color: colors.textSecondary,
    cursor: 'pointer',
    transition: 'color 0.2s ease',
    textDecoration: 'none',
  };
  const go = (tab) => { onNavigate(tab); window.scrollTo({ top: 0 }); };
  const hover = (e) => { e.currentTarget.style.color = colors.gold; };
  const unhover = (e) => { e.currentTarget.style.color = colors.textSecondary; };

  return (
    <footer style={{
      backgroundColor: colors.creamBg,
      borderTop: `1px solid ${colors.borderSubtle}`,
      padding: '40px 24px 56px',
      textAlign: 'center',
    }}>
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '14px 28px',
        marginBottom: '22px',
      }}>
        <button style={linkStyle} onClick={() => go('privacy')} onMouseEnter={hover} onMouseLeave={unhover}>
          Privacy
        </button>
        <button style={linkStyle} onClick={() => go('disclaimer')} onMouseEnter={hover} onMouseLeave={unhover}>
          Disclaimer
        </button>
        <button style={linkStyle} onClick={() => go('terms')} onMouseEnter={hover} onMouseLeave={unhover}>
          Terms
        </button>
        <a href={`mailto:${CONTACT_EMAIL}`} style={linkStyle} onMouseEnter={hover} onMouseLeave={unhover}>
          Contact
        </a>
      </div>
      <p style={{
        fontSize: isMobile ? '12px' : '11px',
        fontWeight: '300',
        fontStyle: 'italic',
        color: colors.textMuted,
        margin: 0,
        letterSpacing: '0.3px',
      }}>
        © {new Date().getFullYear()} Cuspli · For entertainment only
      </p>
    </footer>
  );
}

export default Footer;
